import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

export const appControllerCheckAuth = (params?: IFetchConfig) =>
  fetch<{
    ASTERISK_DTMF_OPEN_CODE: string;
  }>("GET", `auth`, null, params);
